import { render, staticRenderFns } from "./CreateWarehouse.vue?vue&type=template&id=bae43160&scoped=true"
import script from "./CreateWarehouse.vue?vue&type=script&lang=js"
export * from "./CreateWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae43160",
  null
  
)

export default component.exports